import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "create-form" }
const _hoisted_2 = { for: "i_name" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { for: "i_code" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { for: "i_sales" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { for: "i_order" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { for: "i_po" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { for: "i_op_manager" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { for: "i_invoice" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { for: "i_sap" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { for: "i_from" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { for: "i_to" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { for: "i_division" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { for: "i_country" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "full-width" }
const _hoisted_27 = { class: "buttons" }

import { ServiceItem } from "@/services/entities/ServiceItem";
import { useSettingsStore } from "@/stores/setting";
import VueSelect from "vue-select";
import { formatMXDate } from "@/common/date";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceForm',
  props: {
    value: { Type: {} as ServiceItem, default: {} as ServiceItem }
},
  setup(__props) {

const settingsStore = useSettingsStore();

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "header"),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_2, [
          _cache[14] || (_cache[14] = _createTextVNode("Service Name", -1)),
          (!props.value?.blServiceName)
            ? (_openBlock(), _createElementBlock("b", _hoisted_3, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_name",
          type: "string",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.value.blServiceName) = $event))
        }, null, 512), [
          [_vModelText, props.value.blServiceName]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_4, [
          _cache[15] || (_cache[15] = _createTextVNode("BL PG Code", -1)),
          (!props.value.blpgCode)
            ? (_openBlock(), _createElementBlock("b", _hoisted_5, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_code",
          type: "string",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((props.value.blpgCode) = $event))
        }, null, 512), [
          [_vModelText, props.value.blpgCode]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_6, [
          _cache[16] || (_cache[16] = _createTextVNode("Sales order", -1)),
          (!props.value.mxSalesOrder)
            ? (_openBlock(), _createElementBlock("b", _hoisted_7, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_sales",
          type: "string",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((props.value.mxSalesOrder) = $event))
        }, null, 512), [
          [_vModelText, props.value.mxSalesOrder]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_8, [
          _cache[17] || (_cache[17] = _createTextVNode("Order value", -1)),
          (!props.value.orderValue)
            ? (_openBlock(), _createElementBlock("b", _hoisted_9, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_order",
          type: "number",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((props.value.orderValue) = $event))
        }, null, 512), [
          [_vModelText, props.value.orderValue]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_10, [
          _cache[18] || (_cache[18] = _createTextVNode("PO number", -1)),
          (!props.value.poNumber)
            ? (_openBlock(), _createElementBlock("b", _hoisted_11, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_po",
          type: "string",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((props.value.poNumber) = $event))
        }, null, 512), [
          [_vModelText, props.value.poNumber]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_12, [
          _cache[19] || (_cache[19] = _createTextVNode("Operations manager", -1)),
          (!props.value.operationsManager)
            ? (_openBlock(), _createElementBlock("b", _hoisted_13, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_op_manager",
          type: "string",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((props.value.operationsManager) = $event))
        }, null, 512), [
          [_vModelText, props.value.operationsManager]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_14, [
          _cache[20] || (_cache[20] = _createTextVNode("Invoice address", -1)),
          (!props.value.invoiceAddress)
            ? (_openBlock(), _createElementBlock("b", _hoisted_15, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_invoice",
          type: "string",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((props.value.invoiceAddress) = $event))
        }, null, 512), [
          [_vModelText, props.value.invoiceAddress]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_16, [
          _cache[21] || (_cache[21] = _createTextVNode("SAP number", -1)),
          (!props.value.sapNumber)
            ? (_openBlock(), _createElementBlock("b", _hoisted_17, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_sap",
          type: "string",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((props.value.sapNumber) = $event))
        }, null, 512), [
          [_vModelText, props.value.sapNumber]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_18, [
          _cache[22] || (_cache[22] = _createTextVNode("Valid from", -1)),
          (!props.value.validFrom)
            ? (_openBlock(), _createElementBlock("b", _hoisted_19, "*"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_VueDatePicker, {
          teleport: true,
          id: "i_from",
          "enable-time-picker": false,
          modelValue: props.value.validFrom,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((props.value.validFrom) = $event)),
          format: _unref(formatMXDate)
        }, null, 8, ["modelValue", "format"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_20, [
          _cache[23] || (_cache[23] = _createTextVNode("Valid to", -1)),
          (!props.value.validTo)
            ? (_openBlock(), _createElementBlock("b", _hoisted_21, "*"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_VueDatePicker, {
          teleport: true,
          id: "i_to",
          "enable-time-picker": false,
          modelValue: props.value.validTo,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((props.value.validTo) = $event)),
          format: _unref(formatMXDate)
        }, null, 8, ["modelValue", "format"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_22, [
          _cache[24] || (_cache[24] = _createTextVNode("Division", -1)),
          (!props.value.divisionId)
            ? (_openBlock(), _createElementBlock("b", _hoisted_23, "*"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(VueSelect), {
          appendToBody: true,
          label: "name",
          options: _unref(settingsStore).getDivisions,
          clearable: false,
          modelValue: props.value.divisionId,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((props.value.divisionId) = $event)),
          reduce: (item) => item.id
        }, null, 8, ["options", "modelValue", "reduce"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_24, [
          _cache[25] || (_cache[25] = _createTextVNode("Country", -1)),
          (!props.value.countryId)
            ? (_openBlock(), _createElementBlock("b", _hoisted_25, "*"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(VueSelect), {
          appendToBody: true,
          label: "name",
          options: _unref(settingsStore).getCountries,
          clearable: false,
          modelValue: props.value.countryId,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((props.value.countryId) = $event)),
          reduce: (item) => item.id
        }, null, 8, ["options", "modelValue", "reduce"])
      ]),
      _createElementVNode("div", null, [
        _cache[26] || (_cache[26] = _createElementVNode("label", { for: "i_link" }, "Link", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "i_link",
          type: "url",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((props.value.link) = $event))
        }, null, 512), [
          [_vModelText, props.value.link]
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _cache[27] || (_cache[27] = _createElementVNode("label", { for: "i_description" }, "Description", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "i_description",
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((props.value.description) = $event))
        }, null, 512), [
          [_vModelText, props.value.description]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _renderSlot(_ctx.$slots, "buttons")
    ])
  ], 64))
}
}

})